import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";

@Component({
  selector: "app-view",
  templateUrl: "./view.component.html",
  styleUrls: ["./view.component.css"],
})
export class ViewComponent implements OnInit {
  dispenseArray: any = [];
  supers: any = [];
  userSessionData: any = JSON.parse(sessionStorage.getItem("userSession"));
  myArr: any = [];
  paramId: any;
  month: any;
  monthName: String;

  monthArrFull: any = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  monthArr: Array<String> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  year: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superadminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.month = Number(param.id); // 1–12
      this.year = Number(param.year);
      this.monthName = this.monthArr[this.month - 1]; 
    });
  }

  ngOnInit(): void {
    this.getDispense();
  }

  getDispense() {
    this.spinner.show();

    this.superadminService
      .getMonthlyDispenseBySupervisor(this.year, this.month)
      .subscribe({
        next: (res: any) => {
          if (!res.status) {
            this.toastr.error(res.message);
            this.spinner.hide();
            return;
          }

          let finalArray = res.data || [];
          const role = this.userSessionData.user_role_id[0];

          // Role-based filtering
          if (role !== 1 && role !== 7) {
            finalArray = finalArray.filter(
              (item: any) => item.supervisorId === this.userSessionData._id
            );
          }

          // Direct assignment (backend already resolved names)
          this.dispenseArray = finalArray.map((item: any) => ({
            supervisorId: item.supervisorId,
            SupervisorName: item.supervisorName,
            amount: item.amount,
            companyId: item.companyId,
            companyName: item.companyName,
          }));

          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error("Failed to load monthly dispense");
        },
      });
  }

  backTo() {
    window.history.back();
  }
}
